/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseTreeStructureApi } from './BaseTreeStructureApi';

export class OrganizationApi extends BaseTreeStructureApi {
  endPoint: string = '/api/admin/organizations';
}
